module.exports = __webpack_public_path__ + "static/img/6.9a5da4c5.png";